import { Api } from '@/services/Api';

export default { 
    getSecurityProcessByCriteria(body = { keyword: '' }) {
        return Api().post('/SecurityProcess/GetSecurityProcessbyCriteria', body);
    },
    GetSecurityProcessByUserId(body = { keyword: '' }) {
        return Api().post('/SecurityProcess/GetSecurityProcessByUserId', body);
    },
    saveSecurityProcess(body) {
        return Api().post(`/SecurityProcess`, body);
    },
}